import React from "react";
import ToastMessage from "react-native-toast-message";

import { mq } from "utils";
import { config } from "./configs";
import { Platform } from "react-native";

function Provider() {
  return (
    <ToastMessage
      position="top"
      config={config}
      topOffset={Platform.OS === "web" ? 10 : 35}
      visibilityTime={2000}
    />
  );
}

const success = (args: ToastT) =>
  ToastMessage.show({
    type: "success",
    text1: args.title,
    text2: args.message,
  });

const error = (args: ToastT) =>
  ToastMessage.show({ type: "error", text1: args.title, text2: args.message });

const warning = (args: ToastT) =>
  ToastMessage.show({
    type: "warning",
    text1: args.title,
    text2: args.message,
  });

const info = (args: ToastT) =>
  ToastMessage.show({ type: "info", text1: args.title, text2: args.message });

export default { Provider, success, error, warning, info };
